import { Icon } from '@iconify/react';
import { Box, Button, Card, IconButton, styled, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeItemAction } from '../../../redux/slices/selectCreateComponent';

const CuztomCard = styled(Card)(() => ({
  marginTop: '15px',
  padding: '20px 15px',
  display: 'flex',
  alignItems: 'center',
  gap: '20px'
}));

const BoxData = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '90px 1fr'
}));

function CardSelectedItem({ selectCreateId, showedProps = [] }) {
  const [formatItem, setFormatItem] = useState([]);
  const [empty, setEmpty] = useState(true);
  const { itemsSelected } = useSelector((state) => state.selectCreate);
  const dispatch = useDispatch();

  console.log('el item', itemsSelected);

  const removeItem = () => {
    dispatch(removeItemAction(selectCreateId));
  };

  useEffect(() => {
    const dataItemArr = itemsSelected.filter((it) => it.selectCreateId === selectCreateId);
    const dataItem = dataItemArr[0];
    const myArr = [];
    if (dataItemArr.length) {
      setEmpty(false);
      showedProps.map((prop) => {
        const newObj = {};
        const { key, label } = prop;
        newObj.value = dataItem[key];
        newObj.label = label;
        newObj.key = key;
        console.log('asdasd', key, label);

        console.log(newObj);
        myArr.push(newObj);
        return false;
      });
      // const arr = Object.entries(dataItem[0]).map(([key, value]) => ({ key, value }));
      setFormatItem(myArr);
    } else {
      setEmpty(true);
    }
  }, [itemsSelected, selectCreateId, showedProps]);

  // useEffect(() => {
  //   const myArr = [];
  //   if (showedProps.length) {
  //     showedProps.map((prop) => {
  //       const newObj = {};
  //       const { key, label } = prop;
  //       newObj.value = itemsSelected[key];
  //       newObj.label = label;
  //       newObj.key = key;
  //       console.log('asdasd', key, label);

  //       console.log(newObj);
  //       myArr.push(newObj);
  //       return false;
  //     });
  //   }
  //   console.log('selected', myArr);
  //   setFormatItem(myArr);
  // }, [itemsSelected, showedProps]);
  return (
    <>
      {empty ? (
        <Typography>No hay items selecionados</Typography>
      ) : (
        <CuztomCard>
          <Box sx={{ flexGrow: 1 }}>
            {formatItem?.map((it, i) => (
              <BoxData key={i}>
                <Typography variant="subtitle2">{it.label}:</Typography>
                <Typography variant="body2">{it.value}</Typography>
              </BoxData>
            ))}
          </Box>
          <Box sx={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
            <Tooltip title="Dirección selecionada">
              <IconButton size="large" color="info">
                <Icon fontSize="30px" icon="eva:checkmark-circle-2-fill" />
              </IconButton>
            </Tooltip>
            <IconButton onClick={removeItem} size="large" color="info">
              <Icon icon="eva:trash-2-outline" />
            </IconButton>
          </Box>
        </CuztomCard>
      )}
    </>
  );
}

export default CardSelectedItem;
